import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { Loader } from '@/components';
import { LabList, JamList } from '@/components/labList/LabList';
import { useClassroomData } from '@/data/useClassroomData';
import { isEmpty } from '@/utils/helpers';

import messages from './ClassPage.messages';

const ClassPage = () => {
    const { classroomId } = useParams();
    const { formatMessage } = useIntl();
    const { classData } = useClassroomData(classroomId);
    const { course = {}, jamTrainings = {}, content = [] } = classData ?? {};
    const { title: courseTitle, abstract: classAbstract } = course;
    const jams = jamTrainings.trainings ?? [];

    return (
        <Loader message={formatMessage(messages.loading)} isLoading={isEmpty(course)}>
            <LabList title={courseTitle} description={classAbstract} labs={content} />
            <JamList title={courseTitle} jamTrainings={jams} />
        </Loader>
    );
};

export default ClassPage;
